// extracted by mini-css-extract-plugin
export default {"highlight":"OperationRecordsTable_highlight__fkSnZ","listCon":"OperationRecordsTable_listCon__xkOit","table_box":"OperationRecordsTable_table_box__iix3x"};